import $ from 'jquery'

export default class formRangeButtons {
    constructor (element) {
        this.$element = $(element)

        this.$input = this.$element.find('input').eq(0)

        this.$input.on('change', this.handleInputChange.bind(this))
        this.$input.on('input', this.handleInputChange.bind(this))

        const buttonPlusSelector = this.$element.data('plusButtonSelector')
        this.$buttonPlus = this.$element.find(buttonPlusSelector)
        this.$buttonPlus.on('click', this.handlePlusButtonClick.bind(this))

        const minusButtonSelector = this.$element.data('minusButtonSelector')
        this.$buttonMinus = this.$element.find(minusButtonSelector)
        this.$buttonMinus.on('click', this.handleMinusButtonClick.bind(this))

        this.buttonStepSize = parseInt(this.$element.data('buttonStepSize'), 10)
        console.log(this)
    }

    handlePlusButtonClick (event) {
        event.preventDefault()
        const max = parseInt(this.$input.attr('max'), 10)
        let newVal = parseInt(this.$input.val(), 10) + this.buttonStepSize
        if (newVal > max) {
            newVal = max
        }
        this.$input.val(newVal)
        this.$input.trigger('change')
    }

    handleMinusButtonClick (event) {
        event.preventDefault()
        const min = parseInt(this.$input.attr('min'), 10)
        let newVal = parseInt(this.$input.val(), 10) - this.buttonStepSize
        if (newVal < min) {
            newVal = min
        }
        this.$input.val(newVal)
        this.$input.trigger('change')
    }

    handleInputChange (event) {
    }

    destroy () {

    }
}
